import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSystemId, useSystemConfig } from "../../hooks/useReduxSelectors";
import AlarmsTabs from "../../components/alarms/alarmsView/tabs/AlarmsTabs";
import { getAllDeviceAlarmsHistory } from "../../ducks/alarmsHistoryDuck";

const AlarmsViewContainer = () => {
  const dispatch = useDispatch();
  const systemId = useSystemId();
  const config = useSystemConfig();

  useEffect(() => {
    if (config && Object.keys(config).length > 0) {
      dispatch(getAllDeviceAlarmsHistory(systemId));
    }
  }, [dispatch, config, systemId]);


  return (
    <Box id="AlarmsContainer" sx={{ flex: '1 1 0', minHeight: 0, flexDirection: 'column', minWidth: 0, mt: 2, display: 'flex', pb: '10px', position: 'relative', m: '10px', width: '100%' }}>
      <AlarmsTabs />
    </Box>
  );
};

export default withTranslation("common")(AlarmsViewContainer);
